"use strict";

exports.__esModule = true;
var _ElementPathRenderer = require("./ElementPathRenderer");
Object.keys(_ElementPathRenderer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ElementPathRenderer[key]) return;
  exports[key] = _ElementPathRenderer[key];
});